<div fxLayout="row wrap" fxLayoutAlign="center" class="p-20">

    <!-- <div class="fuse-card">
  
        <div class="p-16">
            <div class="h5 secondary-text">Impressions</div>
            <div class="font-size-54 font-weight-300 line-height-1 mt-8">87.4M</div>
        </div>
  
        <div class="p-16 pt-0">
            <span class="green-fg">+12.3%</span>
            of target
        </div>
  
    </div> -->
    <div class="statusDiv">
        <!-- <div class="roundEdg done mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
        <h2>La base de datos de colaboradores está almacenada correctamente</h2>
        <mat-icon class="ml-20 s-40">check_circle</mat-icon>
      </div> -->
        <div class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
            <h2>No ha cargado la base de datos de colaboradores</h2>
            <mat-icon class="ml-20 s-40">error_outline</mat-icon>
        </div>
    </div>

    <div class="mt-40" fxFlex="100" fxLayout="row" fxLayoutAlign="space-around stretch">
        <div class="mat-elevation-z3 p-20" fxFlex="40" fxLayout="column" fxLayoutAlign="space-between stretch">
            <h2 class="mt-0">Información</h2>
            <mat-divider></mat-divider>
            <div class="mt-20 mb-20">
                <div class="h4 secondary-text">Número de colaboradores</div>
                <div class="font-size-54 font-weight-300 line-height-1 mt-8">65536</div>
            </div>
            <mat-divider></mat-divider>
            <div class="mt-20">
                <div class="h4 secondary-text">Fecha de carga</div>
                <div class="font-size-24 font-weight-300 line-height-1 mt-8">27 de septiembre de 2019</div>
            </div>
        </div>
        <div class="mat-elevation-z3 p-20" fxFlex="40" fxLayout="column" fxLayoutAlign="start stretch">
            <h2 class="mt-0">Operaciones</h2>
            <mat-divider></mat-divider>
            <div class="mt-20" fxLayout="column" fxLayoutAlign="start center">
                <div class="h4 secondary-text">¿Qué desea realizar?</div>
                <div class="mt-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch">
                    <button mat-raised-button class="mb-20 primary">
              Descargar la base de datos
              <mat-icon class="ml-20">cloud_download</mat-icon>
            </button>

                    <button mat-raised-button class="mb-20 warn">
              Eliminar la base de datos
              <mat-icon class="ml-20">delete_forever</mat-icon>
            </button>

                </div>
            </div>

        </div>
    </div>

    <!-- <div class="uploadfilecontainer" (click)="fileInput.click()" appDragDrop
      (onFileDropped)="uploadFile($event)" *ngIf="totRows == 0 && !cargandoBD"
      [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
      <input hidden type="file" #fileInput (change)="onFileChange($event)">
      <h1>{{'CERTIFICAR.COLABORADORES.UPLOAD' | translate}}</h1>
    </div> -->

    <!--<ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="dropped($event)">
        <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
            <p (click)="openFileSelector()">Optional custom content that replaces the the entire default content.</p>
        </ng-template>
    </ngx-file-drop>-->

    <div class="contenCargando" *ngIf="cargandoBD">
        <h1>{{'CERTIFICAR.COLABORADORES.PROCESO.STP1' | translate}}</h1>
        <div class="porcenBD">
            <mat-progress-bar mode="indeterminate" #porcenBD></mat-progress-bar>
        </div>

    </div>

    <div class="contenCargando" *ngIf="guardandoBD">
        <h1>{{'CERTIFICAR.COLABORADORES.PROCESO.STP2' | translate}}</h1>
        <mat-progress-bar mode="indeterminate" #porcenBD></mat-progress-bar>
    </div>

    <div *ngIf="!guardandoBD">
        <div class="files-list" *ngFor="let file of files;let i=index" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
            <p>{{ file }}</p>
            <button class="delete-file accent" (click)="deleteAttachment(i,true)" mat-raised-button matTooltip="{{'CERTIFICAR.COLABORADORES.REMOVE' | translate}}">
          <!-- <img src="assets/images/Recycle_Bin_Full.png"> -->
          <mat-icon>delete</mat-icon>
        </button>
        </div>
    </div>

    <!-- <img [src]="imgURL" *ngIf="imgURL" style="height: 30%; width: 30%;"> -->

    <button mat-button (click)="enviarBD()" *ngIf="totRows > 0 && !guardandoBD">{{'CERTIFICAR.COLABORADORES.SEND' | translate}}</button>
    <!-----------boton finalizar paso---------->
    <div fxLayout="column" fxLayoutAlign="space-around stretch" class="finishBt">
        <button *ngIf="!pasoCompleto" (click)="completarPaso()" mat-raised-button class="boton undone" fxLayout="row" fxLayoutAlign="center center">
        {{'CERTIFICAR.COLABORADORES.STATUS.DONE' | translate}}
        <mat-icon>check_box_outline_blank</mat-icon>
      </button>
        <button *ngIf="pasoCompleto" (click)="completarPaso()" mat-raised-button class="boton done" fxLayout="row" fxLayoutAlign="center center">
        {{'CERTIFICAR.COLABORADORES.STATUS.PEND' | translate}}
        <mat-icon>check_box</mat-icon>
      </button>
    </div>

</div>